module.exports = "<h1>Chuck Norris Facts</h1>\n\n<router-outlet></router-outlet>\n"